/** Общая сетка шапки и строк сметы по ЖК. */
export const RESIDENT_SMETA_GRID_MIN_WIDTH_PX = 1020;

/** @typedef {'left'|'right'|'center'} GridAlign */

/**
 * @typedef {Object} ResidentSmetaGridCol
 * @property {string} key
 * @property {string} width
 * @property {GridAlign} align
 * @property {string} [label] — однострочный заголовок
 * @property {string} [labelTop] — верхняя строка составного заголовка
 * @property {string} [labelBottom] — нижняя строка составного заголовка
 */

/** @type {ResidentSmetaGridCol[]} */
export const RESIDENT_SMETA_GRID_COLS = [
  {
    key: "title",
    label: "Наименование работ и материалы",
    width: "30rem",
    align: "left",
  },
  {
    key: "unit",
    label: "Ед. изм",
    width: "3.25rem",
    align: "left",
  },
  {
    key: "qty",
    label: "Объем / Кол-во",
    width: "3.75rem",
    align: "right",
  },
  {
    key: "norm",
    label: "Норма расхода",
    width: "4rem",
    align: "right",
  },
  {
    key: "price",
    label: "Цена",
    width: "4.25rem",
    align: "right",
  },
  {
    key: "wsum",
    label: "Стоимость СМР",
    width: "6.5rem",
    align: "right",
  },
  {
    key: "msum",
    label: "Материалы и оборудование",
    width: "7rem",
    align: "right",
  },
  {
    key: "ttl",
    label: "Стоимость всего",
    width: "6rem",
    align: "right",
  },
];

export const RESIDENT_SMETA_GRID_COL_COUNT = RESIDENT_SMETA_GRID_COLS.length;
